// extracted by mini-css-extract-plugin
export default {"pill":"SelectionPill_pill__EhAM2","disabled":"SelectionPill_disabled__RECGV","label":"SelectionPill_label__DRHv3","removeButton":"SelectionPill_removeButton__MPzud"};